import React from "react";
import PropTypes from "prop-types";

import { BASE_ASSETS_URL } from "constants/app";
import styles from './errorCard.component.scss';

export default function ErrorCard({ onRefresh }) {
  return (
    <div className={styles.errorCard}>
      <img src={`${BASE_ASSETS_URL}images/error-card-graphic.svg`} />
      <div className={styles.refreshInfo}>
        Trouble while loading the data. {onRefresh && <span className={styles.refreshText} onClick={onRefresh}>Refresh</span>}
      </div>
    </div>
  );
}

ErrorCard.defaultProps = {
  onRefresh: ()=>{}
}

ErrorCard.propTypes = {
  onRefresh: PropTypes.func
}
